var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon2, _polygon3, _rect, _line, _path28, _circle, _line2, _path29, _circle2, _line3, _path30, _circle3, _path31, _circle4, _line4, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvm1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#812990;}.cls-2{fill:#fff;}.cls-3{fill:#d5ddeb;}.cls-4,.cls-5{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-4{stroke-dasharray:2 2;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.61 402.12 234.46 346.84 50.2 346.84 50.2 402.12 197.61 402.12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.36,361.11h-.77v2.18h-.45v-2.18h-.78v-.45h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.18,360.66v2.63h-.45v-1.86l-.87,1.34-.86-1.34v1.86h-.45v-2.63H177l.82,1.28.83-1.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107,367.49v.85a5.66,5.66,0,0,0-1.5-.81,5.52,5.52,0,0,0-1.94-.32,5.76,5.76,0,0,0-2.26.44,5.57,5.57,0,0,0-1.8,1.2,5.43,5.43,0,0,0-1.18,1.78,5.82,5.82,0,0,0,0,4.34,5.53,5.53,0,0,0,1.18,1.78,5.39,5.39,0,0,0,1.8,1.19,5.76,5.76,0,0,0,2.26.44h.23a6.16,6.16,0,0,0,2.28-.43v-3h0a3.06,3.06,0,0,1-1,.66,3.35,3.35,0,0,1-1.22.23,4.38,4.38,0,0,1-.52,0h0a3.47,3.47,0,0,1-.72-.19,2.84,2.84,0,0,1-1-.66,2.93,2.93,0,0,1,0-4.3,3.13,3.13,0,0,1,1-.66,3.22,3.22,0,0,1,1.24-.23,3.14,3.14,0,0,1,2.27.89,2.88,2.88,0,0,1,.94,2.16v5.57h2.67V367.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.67,378.38l-5.94-5.72v5.72H87.06V363.3h2.67V369l5.94-5.68h3.79l-7.83,7.51,7.83,7.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.63,367.21a4.94,4.94,0,0,1,2,.4,4.62,4.62,0,0,1,1.53,1.08,4.93,4.93,0,0,1,1,1.6,5.38,5.38,0,0,1,.34,1.94v6.15H118.8v-6.15a2.24,2.24,0,0,0-.78-1.75,2.71,2.71,0,0,0-3.68,0,2.3,2.3,0,0,0-.76,1.75v6.15H110.9V367.51h2.68v.81a5.24,5.24,0,0,1,1.36-.8A4.54,4.54,0,0,1,116.63,367.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.92,367.51a4.76,4.76,0,0,1,1.79-.32v2.55a3.14,3.14,0,0,0-2.27.89,2.94,2.94,0,0,0-.94,2.16v5.59h-2.68V367.49h2.68v.83A5.64,5.64,0,0,1,152.92,367.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.77,367.21a6,6,0,0,1,2.29.44,5.93,5.93,0,0,1,1.88,1.2,5.64,5.64,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.68,5.68,0,0,1-3.14,3,6.21,6.21,0,0,1-4.59,0,5.69,5.69,0,0,1-1.87-1.19,5.63,5.63,0,0,1-1.27-1.78,5.46,5.46,0,0,1,0-4.34,5.52,5.52,0,0,1,1.27-1.78,5.88,5.88,0,0,1,1.87-1.2A6,6,0,0,1,160.77,367.21Zm0,2.55a3.18,3.18,0,0,0-2.28.89,3,3,0,0,0,1,5,3.45,3.45,0,0,0,1.24.23,3.31,3.31,0,0,0,1.22-.23,3.06,3.06,0,0,0,1-.66,2.93,2.93,0,0,0,0-4.3A3.24,3.24,0,0,0,160.77,369.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.29,367.21a6,6,0,0,1,2.3.44,5.88,5.88,0,0,1,1.87,1.2,5.34,5.34,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.45,5.45,0,0,1-1.26,1.78,5.69,5.69,0,0,1-1.87,1.19,6.23,6.23,0,0,1-4.6,0,5.7,5.7,0,0,1-3.13-3,5.35,5.35,0,0,1,0-4.34,5.64,5.64,0,0,1,1.26-1.78,6,6,0,0,1,1.87-1.2A6.08,6.08,0,0,1,173.29,367.21Zm0,2.55a3.14,3.14,0,0,0-2.27.89,2.93,2.93,0,0,0,0,4.3,2.8,2.8,0,0,0,1,.66,3.49,3.49,0,0,0,1.24.23,3.4,3.4,0,0,0,1.23-.23,3.15,3.15,0,0,0,1-.66,3,3,0,0,0,0-4.3A3.28,3.28,0,0,0,173.29,369.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.67,367.49v.85a5.82,5.82,0,0,0-1.5-.81,5.56,5.56,0,0,0-1.94-.32,5.76,5.76,0,0,0-2.26.44,5.46,5.46,0,0,0-1.8,1.2,5.28,5.28,0,0,0-1.18,1.78,5.69,5.69,0,0,0,0,4.34,5.38,5.38,0,0,0,1.18,1.78,5.29,5.29,0,0,0,1.8,1.19,5.76,5.76,0,0,0,2.26.44h.22a6.18,6.18,0,0,0,2.29-.43v-3h0a3.06,3.06,0,0,1-1,.66,3.4,3.4,0,0,1-1.23.23,4.55,4.55,0,0,1-.52,0h0a3.55,3.55,0,0,1-.71-.19,2.76,2.76,0,0,1-1-.66,2.93,2.93,0,0,1,0-4.3,3,3,0,0,1,1-.66,3.2,3.2,0,0,1,1.23-.23,3.16,3.16,0,0,1,2.28.89,2.88,2.88,0,0,1,.94,2.16v5.57h2.67V367.49Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.69,367.49v.85a5.75,5.75,0,0,0-1.49-.81,4.92,4.92,0,0,0-1-.24,6.93,6.93,0,0,0-1.15-.1,5.53,5.53,0,0,0-2.22.44,5.23,5.23,0,0,0-1.74,1.19A5.51,5.51,0,0,0,123,370.6a5.88,5.88,0,0,0-.4,2.19h0A5.62,5.62,0,0,0,123,375a5.56,5.56,0,0,0,1.19,1.78,5.25,5.25,0,0,0,1.79,1.19,5.81,5.81,0,0,0,2.27.44h.39a6.15,6.15,0,0,0,2.11-.42v-3h0a3.06,3.06,0,0,1-1.05.66,3.31,3.31,0,0,1-1.22.23,4.38,4.38,0,0,1-.52,0h0a3.47,3.47,0,0,1-.72-.19,2.92,2.92,0,0,1-1-.66,2.86,2.86,0,0,1-.93-2.15,2.81,2.81,0,0,1,.22-1.13l0-.09a3.18,3.18,0,0,1,.68-.93,3.28,3.28,0,0,1,2.28-.89,3.14,3.14,0,0,1,2.27.89,2.85,2.85,0,0,1,.68.93.36.36,0,0,1,0,.09,2.86,2.86,0,0,1,.22,1.14V377a2.82,2.82,0,0,1-.94,2.14,3.07,3.07,0,0,1-2.27.91,3.12,3.12,0,0,1-1.61-.42l-1.94,1.82a6.15,6.15,0,0,0,1.65.85,6.13,6.13,0,0,0,4.2-.15,6,6,0,0,0,1.87-1.21,5.56,5.56,0,0,0,1.26-1.77,5.31,5.31,0,0,0,.46-2.17v-9.55Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.17,387.59v.71H87.06v-4.05h3V385H87.85v1h1.84v.69H87.85v.91Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.3,383.91v4.34h-.81v-.19a1.8,1.8,0,0,1-.9.24,1.62,1.62,0,0,1,0-3.23,1.78,1.78,0,0,1,.9.24v-1.4Zm-.81,3.4v-1.26a1.18,1.18,0,0,0-.76-.26.9.9,0,1,0,0,1.79A1.19,1.19,0,0,0,94.49,387.31Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.4,385.13v3.12h-.79v-.2a1.53,1.53,0,0,1-.86.25c-.91,0-1.33-.42-1.33-1.44v-1.73h.8v1.73c0,.49.24.72.68.72a1.06,1.06,0,0,0,.71-.25v-2.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.33,387.67a1.51,1.51,0,0,1-1.21.63,1.61,1.61,0,1,1,0-3.22,1.51,1.51,0,0,1,1.22.62l-.52.47a.85.85,0,0,0-.7-.38.9.9,0,1,0,0,1.79.85.85,0,0,0,.7-.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.45,385.13v3.12h-.8V388a1.59,1.59,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.23,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.93a1.24,1.24,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.58,385.79v1.11c0,.56.09.72.5.72.13,0,.25,0,.36,0v.6a2,2,0,0,1-.72.11.9.9,0,0,1-.94-1v-1.53h-.45v-.66h.45v-1.21h.8v1.21h.87v.66Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.36,384.37a.47.47,0,0,1,.46-.47.47.47,0,0,1,.46.47.46.46,0,0,1-.46.47A.47.47,0,0,1,116.36,384.37Zm.07.81h.8v3.12h-.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.66,386.69a1.71,1.71,0,1,1-1.7-1.61A1.66,1.66,0,0,1,122.66,386.69Zm-.78,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,121.88,386.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.64,386.56v1.74h-.8v-1.74c0-.48-.23-.72-.67-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.43,1.43,0,0,1,.83-.25C127.22,385.12,127.64,385.55,127.64,386.56Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.91,385v1.44h1.94v.72h-1.94v1.18h-.79v-4.05h3V385Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.33,386.69a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,141.33,386.69Zm-.79,0a.91.91,0,0,0-.92-.9.9.9,0,1,0,0,1.79A.9.9,0,0,0,140.54,386.69Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.29,385.13v3.12h-.8v-.2a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.44v-1.73h.8v1.73c0,.49.23.72.68.72a1,1,0,0,0,.7-.25v-2.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.42,386.56v1.74h-.8v-1.74c0-.48-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.46,1.46,0,0,1,.84-.25C151,385.12,151.42,385.55,151.42,386.56Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.7,383.91v4.34h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.81,1.81,0,0,1,.91.24v-1.4Zm-.81,3.4v-1.26a1.18,1.18,0,0,0-.76-.26.9.9,0,1,0,0,1.79A1.19,1.19,0,0,0,155.89,387.31Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162,385.13v3.12h-.8V388a1.59,1.59,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.23,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.93a1.24,1.24,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.12,385.79v1.11c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2,2,0,0,1-.72.11.9.9,0,0,1-.95-1v-1.53h-.44v-.66h.44v-1.21h.81v1.21H166v.66Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.9,384.37a.47.47,0,0,1,.46-.47.47.47,0,0,1,.46.47.46.46,0,0,1-.46.47A.47.47,0,0,1,167.9,384.37Zm.07.81h.79v3.12H168Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.2,386.69a1.71,1.71,0,1,1-1.7-1.61A1.66,1.66,0,0,1,174.2,386.69Zm-.78,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,173.42,386.69Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.18,386.56v1.74h-.8v-1.74c0-.48-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.79v-3.12H177v.19a1.46,1.46,0,0,1,.84-.25C178.76,385.12,179.18,385.55,179.18,386.56Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "308.16 346.84 363.43 254.72 418.71 346.84 308.16 346.84"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "418.71 162.59 50.2 162.59 50.2 346.84 308.16 346.84 418.71 162.59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87.06,
    y: 52.04,
    width: 294.8,
    height: 92.13
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.73,
    y1: 374.88,
    x2: 71.97,
    y2: 374.88
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,377.66V373.2l-.86.91-.4-.41,1.34-1.38h.58v5.34Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 5.92,
    cy: 374.88,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.73,
    y1: 257.42,
    x2: 71.97,
    y2: 257.42
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,260.2v-.54c1.92-1.5,3-2.39,3-3.31a1,1,0,0,0-1.12-1,1.78,1.78,0,0,0-1.45.67L4,255.63a2.28,2.28,0,0,1,1.86-.84,1.62,1.62,0,0,1,1.79,1.56c0,1.09-1.11,2.08-2.59,3.26H7.65v.59Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 5.92,
    cy: 257.42,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 363.59,
    y1: 440.79,
    x2: 363.59,
    y2: 307.94
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.14,449.17v-1.35h-2.53v-.55l2.28-3.43h.92v3.39h.75v.59h-.75v1.35Zm0-4.72-1.87,2.78h1.87Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 363.59,
    cy: 446.46,
    r: 5.67
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.77,7.85l.39-.42a1.84,1.84,0,0,0,1.49.7c.78,0,1.25-.39,1.25-1s-.55-.94-1.33-.94H136V5.59h.55c.67,0,1.24-.26,1.24-.88s-.54-.91-1.19-.91a1.78,1.78,0,0,0-1.41.65L134.84,4a2.3,2.3,0,0,1,1.83-.82c1,0,1.8.52,1.8,1.41a1.28,1.28,0,0,1-1.14,1.24,1.36,1.36,0,0,1,1.23,1.32c0,.89-.72,1.54-1.89,1.54A2.25,2.25,0,0,1,134.77,7.85Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 136.78,
    cy: 5.92,
    r: 5.67
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.77,
    y1: 51.56,
    x2: 136.77,
    y2: 11.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvm1);
export default __webpack_public_path__ + "static/media/ivm1.148b3dcbdf4cfcd6ddcccd77a1494550.svg";
export { ForwardRef as ReactComponent };